import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener los administradores
export const fetchAdminsService = async () => {
    const { data } = await axios.get(API_ROUTES.USERS, { params: { role: 'admin', status: 'active' } });
    return data;
};
// Obtener los usuarios normales
export const fetchUsersService = async () => {
    const { data } = await axios.get(API_ROUTES.USERS, { params: { role: 'user', status: 'active' } });
    return data;
};
// Asignar rol admin a usuarios
export const addAdminService = async (userId) => {
    const { data } = await axios.post(API_ROUTES.ADMINS_ADDADMIN, { userid: userId });
    return data;
};
// Quitar rol admin a usuarios
export const removeAdminService = async (userId) => {
    const { data } = await axios.post(API_ROUTES.ADMINS_REMOVE, { userid: userId });
    return data;
};